import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { AuditDataModel } from "../types";

interface AuditState {
  audits: Record<string, {
    collectionData: AuditDataModel | null;
    indexedPages: number;
    siteTitle: string | null;
    timestamp: number;
  }>;
  setAuditData: (url: string, data: { collectionData: AuditDataModel | null; indexedPages: number; siteTitle: string | null }) => void;
}

export const useAuditStore = create<AuditState>()(
  persist(
    (set) => ({
      audits: {},
      setAuditData: (url, data) =>
        set((state) => ({
          audits: {
            ...state.audits,
            [url]: {
              ...data,
              timestamp: Date.now(),
            },
          },
        })),
    }),
    {
      name: "audit-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);